<template>
<td colspan="1">
  <span :class="spanClass">
  <font-awesome-icon :icon="icon" >
    
  </font-awesome-icon>
</span>
</td>
</template>
<script>
export default {
  props: {
   checked:Boolean
  },
  computed: {
    icon(){
      return this.checked?"check":"times";
    },
    spanClass() {
      return {
       'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!this.checked,"action_success":this.checked
        
      };
    }
  }
};
</script>